"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workPacketGeneratorStates = exports.workPacketAssignmentStatuses = exports.workPacketStatuses = void 0;
exports.workPacketStatuses = ['INCOMPLETE', 'COMPLETED', 'EXHAUSTED'];
exports.workPacketAssignmentStatuses = [
    'ASSIGNED',
    'IN_PROGRESS',
    'SUBMITTED',
    'VALIDATED',
    'COMPLETED',
    'EXPIRED',
    'REJECTED',
];
exports.workPacketGeneratorStates = ['RUNNING', 'HALTED'];
//# sourceMappingURL=WorkPackets.js.map